<template>
<v-layout row>
  <v-flex md12>
    <v-card>
      <v-toolbar dense primary-title class="py-0">
        <v-toolbar-title>{{$t('view.perfil.registros.label')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="view.elem.showTable = !view.elem.showTable">
          <v-icon>{{ view.elem.showTable ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
        </v-btn>
      </v-toolbar>      
      <v-slide-y-transition>
        <v-card-text v-show="view.elem.showTable">
          <div class="table-responsive">
            <table id="something" class="table table-striped table-bordered table-hover responsive nowrap dataTables-example "  style="width:100%">
              <thead>
                <tr>
                  <th class="all col-md-2">{{$t('view.monitorCorreos.fechaalta.th')}}</th>
                  <th class="all col-md-2">{{$t('view.monitorCorreos.fechaEnvio.th')}}</th>
                  <th class="desktop tablet mobile col-md-2">{{$t('view.monitorCorreos.de.th')}}</th>
                  <th class="desktop tablet col-md-2">{{$t('view.monitorCorreos.para.th')}}</th>
                  <th class="none">{{$t('view.monitorCorreos.cc.th')}}</th>
                  <th class="none">{{$t('view.monitorCorreos.cco.th')}}</th>
                  <th class="all col-md-2">{{$t('view.monitorCorreos.asunto.th')}}</th>
                </tr>
              </thead>
            </table>
          </div>
        </v-card-text>
      </v-slide-y-transition>
    </v-card>
  </v-flex>
</v-layout>
</template>
<script>
//import BitacoraAPI from "@/services/monitorCorreos";

export default {
  data() {
    return {
      count:0
      , dataTable:undefined
      , view:{
        elem:{
          showTable: true
        }
      }
    }
  }
  , props:{
    pageLength:{
      default:10
      , type:Number
    }
    , responsive:{
      default:true
      , type:Boolean
    }
    , dom:{
      default:'<"html5buttons"B>lTfgitp'
    } 
  }
  ,methods: {
    refreshData(){
      this.dataTable._fnReDraw();
      // this.dataTable._fnAjaxUpdate();
    }
  }
  , computed:{}
  , components: {}
  // Instance Lifecycle Hooks
  , created(){
    //window.$('.dataTables-example').DataTable({});  
  }
  , mounted(){
    const vm = this;
        function formatDate( date, params ) {
      if(date != null)
      {
        var options = {
            year: "numeric"
            , month: "2-digit"
            , day: "2-digit"
            , hour:"2-digit"
            , minute:"2-digit"
            , second:"2-digit"
        };

        if( params ) {
            options = Object.assign( options, params );
        }
        return new Date( date ).toLocaleString( 'es-MX', options );
      }
      else 
      {
        return '';
      }
    };
    this.$nextTick(function(){
      vm.dataTable=window.$('#something').dataTable({     
        "bProcessing": true
        , "bServerSide": true
        , "bPaginate":true
        , "pageLength" : vm.pageLength
        , "language": { "url": '/static/js/dataTables/language/dataTables.spanish.json' }
        , "responsive": true  
        , "ajax":{
          "url": "/api/correo"
          , "type": "POST"
          , "async":true
          ,"headers":{
            "Authorization":`Bearer ${vm.$store.getters.getUserToken}`
          }
          , "data"    : function(data){
            let estatus = vm.$parent.view.elem.input.radio.estatus.selectedEstatus;

            let objFilter = {
              estatus: estatus
            };
            if(typeof objFilter.estatus != undefined){
              data.filtros = JSON.stringify(objFilter);
            }
           
          }
          , "complete": function(response){
            //console.log(response)
          }
          , "error"   : function(error){
            console.log(error)
          }
        }
        , "aaSorting" : [[0, 'desc']]
        , "aoColumns": [
          {
            "data":"fechaalta"
            , "sClass":"text-center"
          },
          {
            "data":"fechaEnvio"
            , "sClass":"text-center none"
          },
          {
            "data":"de"
            , "sClass":"text-center"
          },
          {
            "data":"para"
            , "sClass":"text-center"
          },
          {
            "data":"cc"
            , "sClass":""
           },
          {
            "data":"cco"
            , "sClass":""
          },
          {
            "data":"asunto"
            , "sClass":""
          },
          
        ]
        , "aoColumnDefs":[
          {
            "aTargets": [ 0 ],
            "mData": "fechaalta",
            "mRender": function ( data, type, full ) {
              let fawesome = '<i class="fa fa-spinner fa-spin" style="color:#0077BC;"></i> ';
              switch(full.estatus){
                case 'pendiente':
                  fawesome = '<i class="fa fa-spinner fa-spin" style="color:#0077BC;"></i> ';
                  break;
                case 'enviado':
                  fawesome = '<i class="fa fa-send" style="color:green;"></i> ';
                  break;
                case 'error': 
                  fawesome = '<i class="fa fa-exclamation-circle" style="color:red;"></i> ';
                  break;
              }
              return fawesome + formatDate(data) ;
            }
          }
         , {
            "aTargets": [ 1 ],
            "mData": "fechaEnvio",
            "mRender": function ( data, type, full ) {
              return formatDate(data);
            }
          }
        ]
      });
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/bitacoras/monitorCorreos/DataTable.vue